export const mobileApps = {
  ess: { service: 'HRMS ESS', packageId: 'com.karyasaas.hrmess', dashboard: '/dashboards/ess' },
  team: { service: 'HRMS Team', packageId: 'com.karyasaas.hrmteam', dashboard: '/dashboards/hr' },
  crm: { service: 'CRM', packageId: 'com.karyasaas.crm', dashboard: '/dashboards/crm' },
  fsm: { service: 'FSM', packageId: 'com.karyasaas.fsm', dashboard: '/dashboards/fsm' },
  ims: { service: 'IMS', packageId: 'com.karyasaas.ims', dashboard: '/dashboards/ims' },
};

export function getMobileApp(userAgent = navigator.userAgent) {
  return mobileApps[/\bKaryaHRMS\/(ess|team|crm|fsm|ims)\b/.exec(userAgent)?.[1]] || null;
}